import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
/* eslint-disable */
import axios from 'axios';
import { lang } from '@/lang';
import qs from 'qs';
import { Notification, MessageBox, Message } from 'element-ui';
import { utilCookies } from '@/util/cookies';
import storejs from 'storejs';
import { status } from 'nprogress';
// axios实例
var axiosInstance = axios.create({
  baseURL: storejs.get('base_api') || process.env.VUE_APP_BASE_API,
  timeout: 20000,
  paramsSerializer: function paramsSerializer(params) {
    return qs.stringify(params, {
      encode: true
    });
  }
});
// 错误提示
var errorNotice = function errorNotice(message) {
  return Notification.error({
    message: message,
    duration: 5000
  });
};
var errorMessage = function errorMessage(message) {
  return Message.error({
    message: message,
    duration: 3000
  });
};

// 请求拦截
axiosInstance.interceptors.request.use(function (config) {
  if (config.url) {
    return config;
  }
  throw new axios.Cancel();
}, function (error) {
  errorNotice(error.message);
  return Promise.reject(error);
});

// 响应拦截
axiosInstance.interceptors.response.use(function (response) {
  if (response.data) {
    if (response.data.code !== 1 && response.config.url !== '/auth/qr/status' && response.config.responseType !== 'blob') {
      if (response.data.code === 2003) {
        errorMessage(response.data.message);
        // code 为2003 说明该账户未注册，跳转注册页面
        var hash = window.location.hash;
        var href = window.location.href;
        window.location.href = href.replace(hash, '#/register/index');
      } else if (response.data.code === 2011) {
        // code 为2011 说明该用户为离职状态，不允许登录，直接跳转登录页面
        MessageBox.confirm(response.data.message, '', {
          confirmButtonText: lang.t('submit_btn'),
          center: true,
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(function () {
          utilCookies.removeToken();
          window.location.reload();
        }).catch(function () {});
      } else {
        // 登录相关接口使用Message
        if (response.config.errorMessage) {
          errorMessage(response.data.message);
        } else {
          errorNotice(response.data.message);
        }
        return Promise.reject(response.data);
      }
    }
    return response.data;
  }
}, function (error) {
  var _error$response;
  var message = '';
  var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
  if (error.response) {
    if (status === 401) {
      message = lang.t('15c93583');
      utilCookies.removeToken();
      window.location.reload();
    } else if (status === 403) {
      message = lang.t('5c935839');
    } else if (error.response.data && error.response.data.message) {
      message = error.response.data.message;
    } else if (error.response.data && error.response.data instanceof Blob) {
      var reader = new FileReader();
      reader.addEventListener('loadend', function (e) {
        var text = e.srcElement.result;
        message = JSON.parse(text).message;
      });
      reader.readAsText(error.response.data);
    } else {
      message = "server response error code ".concat(status);
    }
  } else {
    message = error.message;
  }
  status !== 401 && errorNotice(message);
  return Promise.reject(error);
});
var timeZone = function timeZone() {
  var off = Math.abs(new Date().getTimezoneOffset() / 60);
  var end = off.toFixed(2).split('.');
  return "+".concat(end[0], ":").concat(end[1]);
};
export var baseHeaders = function baseHeaders() {
  return {
    Authorization: 'Bearer ' + utilCookies.getToken(),
    'Accept-Language': lang.i18n.locale,
    'X-Token': utilCookies.getCompanyToken(),
    'X-Timezone': timeZone()
  };
};

// 封装axiosRequest
export var axiosRequest = function axiosRequest(option) {
  var headers = baseHeaders();
  headers.Authorization = 'Bearer ' + utilCookies.getToken();
  var config = JSON.parse(JSON.stringify(option));
  config.method === undefined && (config.method = 'post');
  config.hasBaseParamsData === undefined && (config.hasBaseParamsData = true);
  // 公共请求头

  // 添加公共请求头
  config.headers = Object.assign({}, headers, config.headers);
  return axiosInstance.request(config);
};